
import { BasicEntity } from "../../../../core/models/basic-entity";

export class ThirdCommunicationType extends BasicEntity {
public Icon? : string;

 }
